module.exports = __webpack_public_path__ + "media/3_6-4.9934e042.mp3";